import BrandIdentity from '@Guidelines/Component/Brand/BrandIdentity';
import useDisplayedLogo from '@Guidelines/Shell/AppShell/Hooks/useDisplayedLogo';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Link } from 'react-router-dom';

const brandStyle = css`
	${theme.typography.wordmark}
	display: flex;
	align-items: center;
	flex-shrink: 0;
	color: ${theme.colors.ink};
	text-decoration: none;
	white-space: nowrap;
	border-radius: ${theme.radii.xsmall};

	&:focus-visible {
		outline: 2px solid ${theme.colors.accent};
		outline-offset: 4px;
	}
`;

/** Brand mark and name, linking to the home screen. */
const HeaderBrand: React.FC = () => {
	const logo = useDisplayedLogo();

	return (
		<Link to="/" css={brandStyle} aria-label="Dixit — Accueil">
			<BrandIdentity logo={logo} tone="light" size="compact" />
		</Link>
	);
};

export default HeaderBrand;
